import { useQueryClient } from '@tanstack/react-query';
import { useApiMutation } from '@/api/hooks/useMutation';
import { memberInfoKeys } from '@/api/queryKeys';
import type { UpdateMemberProfileRequest } from '@bvengineering/cas-member-gateway-service-client';

/**
 * Hook to update the current member's profile info.
 * This mirrors the mobile app's useUpdateMyInfo hook.
 *
 * @example
 * const { mutate: updateInfo } = useUpdateMemberInfo();
 * updateInfo({ firstName: 'John', lastName: 'Doe' });
 */
export function useUpdateMemberInfo() {
  const queryClient = useQueryClient();

  return useApiMutation({
    mutationFn: (api) => async (request: UpdateMemberProfileRequest) => {
      await api.members.membersControllerUpdateMemberProfile(request);
    },
    onSuccess: () => {
      // Invalidate member info to refetch updated data
      queryClient.invalidateQueries({
        queryKey: memberInfoKeys.detail(),
      });
    },
  });
}
